import { DocumentItem } from "../../models/polymer/Document.model";
import data from "./options.json";

export const shared_documents_list: DocumentItem[] = data.documents;

const solicitor_correspondence_document_codes: string[] = ["SDC01", "SDC02", "SDC03", "SDC04", "SDC05", "SDC06", "SDC07", "SDC08"];
export const solicitor_correspondence_documents: DocumentItem[] = shared_documents_list.filter((document) =>
  solicitor_correspondence_document_codes.includes(document.code)
);

const solicitor_completion_document_codes: string[] = ["SDC09", "SDC10", "SDC11"];
export const solicitor_completion_documents: DocumentItem[] = shared_documents_list.filter((document) =>
  solicitor_completion_document_codes.includes(document.code)
);

const solicitor_lodgement_document_codes: string[] = ["SDC12"];
export const solicitor_lodgement_documents: DocumentItem[] = shared_documents_list.filter((document) =>
  solicitor_lodgement_document_codes.includes(document.code)
);
